import { Grid2 as Grid, Box, Divider } from '@mui/material';

type imagesContentType = {
  alt?: string;
  imageSrc?: string;
}[];

function ImageGrid({ imagesContent }: { imagesContent: imagesContentType }) {
  const imageWidthHeight = { xs: '140px', md: '160px', lg: '220px', xl: '280px' };
  return (
    <Grid container spacing={2} justifyContent="center">
      {imagesContent.map((item, index) => (
        <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index} display="flex" justifyContent="center">
          <Box
            component="img"
            src={item.imageSrc}
            alt={item.alt}
            sx={{
              width: imageWidthHeight,
              height: imageWidthHeight,
              objectFit: 'contain',
            }}
          />
        </Grid>
      ))}
      <Grid size={12} sx={{ width: '40%', margin: 6 }}>
        <Divider sx={{ borderColor: '#001489', borderWidth: 1 }} />
      </Grid>
    </Grid>
  );
}

export default ImageGrid;
